import { TableCell, TableRow, Checkbox, Box, IconButton, Typography } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import ButtonDesplegable from '../../../../../components/Common/ButtonDesplegable'
import DesplegableRubrosProducto from '../DesplegableRubrosProducto'
import { ProductoWProps } from '../Producto'
import ProductoActions from '../ProductoActions'
import { ProductosAdminContext } from '../../../context/productos.context'
import { useContext, useMemo, useState } from 'react'
import { format } from 'date-fns'
import { IProducto } from '../../../types/producto'
import CloseIcon from '@mui/icons-material/Close'
import Loading from '../../../../../components/Common/Loading'

const TableProducto = ({
  producto,
  rubros,
  loading,
  loadingVideo,
  cambiarRubro,
  setOpenMotivos,
  labelRevision,
  changingEstado,
  setOpenDuplicar,
  isDefinitivelyDeleting,
  isDefinitivelyExpiring,
  isSelected,
  setIsSelected,
  loadingRubros,
  eliminarRevision
}: ProductoWProps) => {
  const { productosSeleccionados, setProductosSeleccionados } = useContext(ProductosAdminContext)

  const estaSeleccionado = useMemo(() => {
    return productosSeleccionados.some((p: IProducto) => p.codProducto === producto.codProducto)
  }, [productosSeleccionados, producto])

  const handleCheckboxChange = () => {
    if (estaSeleccionado) {
      setProductosSeleccionados(productosSeleccionados.filter((p: IProducto) => p.codProducto !== producto.codProducto))
    } else {
      setProductosSeleccionados([...productosSeleccionados, producto])
    }
  }
  return (
    <>
      <TableRow
        style={{
          backgroundColor:
            producto.aprobado && !producto.pausado && !producto.vencido
              ? '#b3faa8'
              : producto.rechazado
                ? '#ffaeba'
                : producto.pausado || producto.vencido
                  ? '#ddd'
                  : '#fff'
        }}
      >
        <TableCell align="center">
          <Checkbox
            checked={estaSeleccionado}
            onChange={handleCheckboxChange}
            sx={{
              p: 0,
              m: 0,
              width: 'fit-content',
              alignSelf: 'center'
            }}
          />
        </TableCell>
        <TableCell
          sx={{ cursor: 'pointer' }}
          onClick={() => {
            window.open(producto.sharelink, '_blank')
          }}
        >
          <img
            src={producto.urlFoto}
            // src={"https://http2.mlstatic.com/D_NQ_NP_601375-MLA51645718227_092022-W.jpg"}
            alt={producto.nombre}
            loading="lazy"
            style={{
              width: '100px',
              height: '100px'
            }}
          />
        </TableCell>
        <TableCell sx={{ fontSize: '15px' }}>
          {producto.nombreLocal} - {`(${producto.codLocal})`}
        </TableCell>
        <TableCell sx={{ fontSize: '15px' }}>
          {producto.nombre} - {`(${producto.codProducto})`}
        </TableCell>
        <TableCell width={'350px'}>
          <DesplegableRubrosProducto
            loading={loadingRubros}
            onChange={cambiarRubro}
            nombreRubro={producto.nombreRubro}
            rubros={rubros}
            codActual={producto.codRubro}
            setIsSelected={setIsSelected}
            isSelected={isSelected}
          />
        </TableCell>
        <TableCell sx={{ fontSize: '15px' }}>
          <span>
            {producto.precio}
            <br />
            {producto.informacionPrecio}
          </span>
        </TableCell>
        <TableCell sx={{ fontSize: '15px' }}>{producto.precioMinorista > 0 && producto.precioMinorista}</TableCell>
        <TableCell sx={{ fontSize: '15px', whiteSpace: 'break-spaces' }}>
          {`Pub: ${format(new Date(producto.fechaPublicacion), 'dd/MM/yyyy HH:mm')}\nVto: ${format(
            new Date(producto.fechaVencimiento),
            'dd/MM/yyyy'
          )}`}
        </TableCell>
        <TableCell sx={{ fontSize: '15px' }}>{producto.flags}</TableCell>
        <TableCell
          sx={{
            ...(producto.motivosRevision?.length > 0 && {
              display: 'flex',
              verticalAlign: 'center',
              flexDirection: 'column',
              gap: '10px'
            })
          }}
        >
          {producto.motivosRevision?.length > 0 && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                border: '1px solid red',
                color: 'red',
                borderRadius: '4px'
              }}
            >
              <Typography style={{ padding: '0 0.5rem', fontSize: '14px', whiteSpace: 'nowrap' }}>
                {labelRevision}
              </Typography>
              <Box sx={{ display: 'flex', gap: 0 }}>
                <IconButton size="small" color="error" onClick={() => setOpenMotivos(true)}>
                  <VisibilityIcon fontSize="small" />
                </IconButton>
                <IconButton size="small" color="error" onClick={eliminarRevision}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            </Box>
          )}
          {loading ? (
            <Loading />
          ) : (
            <ButtonDesplegable disabled={loadingVideo} label="Acciones" className="d-flex flex-column" fullWidth={true}>
              <ProductoActions
                changingEstado={changingEstado}
                setOpenDuplicar={setOpenDuplicar}
                isDefinitivelyDeleting={isDefinitivelyDeleting}
                isDefinitivelyExpiring={isDefinitivelyExpiring}
                producto={producto}
              />
            </ButtonDesplegable>
          )}
        </TableCell>
      </TableRow>
    </>
  )
}

export default TableProducto
